import React, { useState, useEffect } from "react";
import { XLg } from "react-bootstrap-icons";
import Popup from "reactjs-popup";
import styles from "./ResetMFAPopup.module.scss";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import loadingGif from "../../../../../../../Assets/Images/Animations/loading-management-console.gif";
import { api } from "../../../../../../../Utils/API";
import { RESET_MFA_LANDING, SEND_VERIFICATION_CODE } from "../../../../../../../Utils/GlobalConstants";
import { GenericServerError } from "../../../../../../../Utils/StaticMessages/GenericErrorMessages";
import { emailRegEx } from "../../../../../../../Utils/RegExPatterns";
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import { loginRequest } from '../../../../../../../authConfig';
import { useMsal } from '@azure/msal-react';
import { encryptPayload, decryptPayload } from "./LocalComponents/encryption";
import CryptoJS from "crypto-js";

const ResetMFAPopup = ({ modalOpen, setModalOpen }) => {

  const { instance } = useMsal();

  // MFA Details
  const [emailIdUsername, setEmailIdUsername] = useState("");
  const [fastAccessPin, setFastAccessPin] = useState("");
  const [verificationCode, setverificationCode] = useState("");

  // FormValidation
  const [verificationCodeError, setverificationCodeError] = useState(false);
  const [fastAccessPinError, setFastAccessPinError] = useState(false);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [sendVerificationCodeMessage, setSendVerificationCodeMessage] =
    useState(null);

  const [validationSuccess, setSendValidationSuccess] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(120);
  const [ipAddress, setIpAddress] = useState(null);
  const [isUserBlocked, setIsUserBlocked] = useState(false);

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    // instance.loginPopup(loginRequest).catch((error) => console.log(error)); Popup
  };

  useEffect(() => {
    let interval;
    if (resendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
      setTimer(120);
    }
    return () => clearInterval(interval);
  }, [resendDisabled, timer]);

  // Post Send Verification Code
  async function sendVerificationCode() {
    setSendVerificationCodeMessage(null);
    if ((fastAccessPin.length === 0 || emailIdUsername.length === 0) ) {
      if(fastAccessPin.length === 0 && emailIdUsername.length === 0){
          setFastAccessPinError(true)
          setverificationCodeError(true);
      }
      else{
        fastAccessPin.length === 0
        ? setFastAccessPinError(true)
        : setverificationCodeError(true);
      }
      
    } else {
      setFormSubmitting(true);
      setSendVerificationCodeMessage(null);
      setResendDisabled(true);
      const secretKey = "K8+BrY5ztRgPX+b416Z3j4NcS9KW5MgS";
      const encryptedFastAccessPin = encryptPayload(fastAccessPin, secretKey);

      // Decrypt for verification
      // const decryptedPin = decryptPayload(encryptedFastAccessPin, secretKey);
      // console.log("Decrypted PIN for verification:", decryptedPin);

      const payload = {
        fastAccessPin: encryptedFastAccessPin,
        email: emailIdUsername,
        ipAddress:ipAddress,
      };
      await api
        .post(SEND_VERIFICATION_CODE, payload)
        .then((resp) => {
          // console.log("Response : ", resp.request.status);
          if (resp.request.status == 200) {
            setSendValidationSuccess(true);
            setSendVerificationCodeMessage({
              status: "success",
              message: "Verification code sent to Registered Email ID, please check your inbox",
            });
            setIsUserBlocked(false);
            setFormSubmitting(false);
          }
        })
        .catch((error) => {
          // console.log("Error : ", error);
          // if(error?.response?.status === 500){
          //   setSendValidationSuccess(true);
          //   setSendVerificationCodeMessage({
          //     status: "success",
          //     message: "Verification code sent to Registered Email ID, please check your inbox",
          //   });
          //   setFormSubmitting(false);
          // }
          // else{
            // console.log(error?.response);
            if(error?.response?.data?.isUserBlocked===true){
              setIsUserBlocked(true);
            }
            else{
              setIsUserBlocked(false);
            }
            setSendVerificationCodeMessage({
            status: "error",
            message: error?.response?.data?.message
              ? error.response.data.message
              : GenericServerError,
          });
          // }
          
          setFormSubmitting(false);
        });
    }
  }


    // Post Send Verification Code
  async function resetMFA() {
      setFormSubmitting(true);
      setSendVerificationCodeMessage(null);
      const secretKey = "K8+BrY5ztRgPX+b416Z3j4NcS9KW5MgS";
      const encryptedFastAccessPin = encryptPayload(fastAccessPin, secretKey);
      const encryptedVerificationCode = encryptPayload(parseInt(verificationCode), secretKey);

      const payload = {
        fastAccessPin: encryptedFastAccessPin,
        email: emailIdUsername,
        verificationCode: encryptedVerificationCode,
        ipAddress:ipAddress,
      };
      await api
        .post(RESET_MFA_LANDING, payload)
        .then((resp) => {
          // console.log("Response : ", resp.request.status);
          if (resp.request.status == 200) {
            setSendVerificationCodeMessage({
              status: "success",
              message: "Your Reset 2FA request has been submitted. Please use QR code to reset 2FA on your next login.",
            });
            setIsUserBlocked(false);
            setFormSubmitting(false);
          }
        })
        .catch((error) => {
          console.log("Error : ", error);
          // if(error?.response?.status === 404){
          //   setSendVerificationCodeMessage({
          //     status: "success",
          //     message: "MFA has been resetted successfuly",
          //   });
          // }
          // else{
            if(error?.response?.data?.isUserBlocked===true){
              setIsUserBlocked(true);
            }
            else{
              setIsUserBlocked(false);
            }
            setSendVerificationCodeMessage({
            status: "error",
            message: error?.response?.data?.message
              ? error.response.data.message
              : GenericServerError,
          });
          // }
          
          setFormSubmitting(false);
        });
  }

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
        .then(response => response.json())
        .then(data => setIpAddress(data.ip));
  }, []);

  return (
    <Popup
      className="custom-modal custom-modal-lg custom-modal-lg-fixed"
      closeOnDocumentClick={false}
      open={modalOpen}
      closeOnDocumentClick={false}
      onClose={() => {
        setEmailIdUsername("");
        setFastAccessPin("");
        setverificationCode("");
        setverificationCodeError(false);
        setFastAccessPinError(false);
        setFormSubmitting(false);
        setSendVerificationCodeMessage(null);
        setSendValidationSuccess(false);
        setModalOpen(false);
        setResendDisabled(false);
        setTimer(120);
        setIsUserBlocked(false);
      }}
      modal
      nested
    >
      {(close) => (
        <div>
          <div className={styles.closeCross}>
            <XLg
              size={24}
              className={`${styles.cross} cpointer`}
              onClick={close}
            />
          </div>

          <Container fluid>
            <h1 className={`my-10 ${styles["reset-mfa-title"]}`}>
              Support - Reset 2FA
            </h1>
            <Row className="mx-0">
              <Col md={12}>
                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label className="text-strong">
                    Registered Email ID <span className="red">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    maxLength={100}
                    disabled={validationSuccess || formSubmitting}
                    value={emailIdUsername}
                    className={styles["emailid-input-box"]}
                    onChange={(e) => {
                      setEmailIdUsername(e.target.value);
                      setverificationCodeError(false);
                      setSendVerificationCodeMessage(null);
                    }}
                  />
                  {verificationCodeError && (
                    <span className="text-small red">
                      Please enter a valid registered email id.
                    </span>
                  )}
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label className="text-strong">
                    Fast Access Pin <span className="red">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    maxLength={100}
                    disabled={validationSuccess || formSubmitting}
                    className={styles["fast-access-pin-input-box"]}
                    value={fastAccessPin}
                     onKeyDown={(e) => {
                       // Allow only numbers, backspace, and delete
                       if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && !e.ctrlKey) {
                         e.preventDefault();
                       }
                     }}
                     onChange={(e) => {
                       const numericValue = e.target.value.replace(/[^0-9]/g, "");
                       setFastAccessPin(numericValue);
                       setFastAccessPinError(false);
                       setSendVerificationCodeMessage(null);
                     }}
                  />
                  {fastAccessPinError && (
                    <span className="text-small red">
                      Please enter valid Fast Access PIN.
                    </span>
                  )}
                  {sendVerificationCodeMessage && !validationSuccess ? (
                    <>
                      <span
                        className={
                          sendVerificationCodeMessage.status === "error"
                            ? "status-error mr-1"
                            : "status-success mr-1"
                        }
                      >
                        &nbsp;
                      </span>
                      <span
                        className={
                          sendVerificationCodeMessage.status === "error"
                            ? "red text-small"
                            : "green text-small"
                        }
                      >
                        {sendVerificationCodeMessage.message}
                      </span>
                    </>
                  ) : (
                    <span className={validationSuccess ? "d-none" : ""}>
                      &nbsp;
                    </span>
                  )}
                </Form.Group>
              </Col>
              {validationSuccess && <Col md={12}>
                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label className="text-strong">
                    Verification Code <span className="red">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    maxLength={100}
                    disabled={sendVerificationCodeMessage?.message === "Your Reset 2FA request has been submitted. Please use QR code to reset 2FA on your next login." || formSubmitting}
                    value={verificationCode}
                     onKeyDown={(e) => {
                       // Allow only numbers, backspace, and delete
                       if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && !e.ctrlKey) {
                         e.preventDefault();
                       }
                     }}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^0-9]/g, "");
                      setverificationCode(numericValue);
                      setSendVerificationCodeMessage(null);
                    }}
                  />
                  {sendVerificationCodeMessage ? (
                    <>
                      <span
                        className={
                          sendVerificationCodeMessage.status === "error"
                            ? "status-error mr-1"
                            : "status-success mr-1"
                        }
                      >
                        &nbsp;
                      </span>
                      <span
                        className={
                          sendVerificationCodeMessage.status === "error"
                            ? "red text-small"
                            : "green text-small"
                        }
                      >
                        {sendVerificationCodeMessage.message}
                      </span>
                    </>
                  ) : (
                    <span className={validationSuccess ? "d-none" : ""}>
                      &nbsp;
                    </span>
                  )}
                </Form.Group>
              </Col>}
            </Row>
            {validationSuccess ? (
              <div className={styles["send-verification-code-button"]}>
                {formSubmitting ? (
                  <Button
                    className={`mx-2 btn-border-light w-md-auto col-xs-12 btn btn-lg ${styles["button-reset-mfa"]}`}
                    variant="light"
                    disabled
                    // onClick={SubmitContactForm}
                  >
                    Resetting 2FA . . .
                  </Button>
                ) : (
                  <Button
                    className={`btn btn-lg ${styles["button-reset-mfa"]}`}
                    onClick={() => resetMFA()}
                    disabled={verificationCode.length===0 || sendVerificationCodeMessage?.message === "Your Reset 2FA request has been submitted. Please use QR code to reset 2FA on your next login."}
                    variant={verificationCode.length===0 || sendVerificationCodeMessage?.message === "Your Reset 2FA request has been submitted. Please use QR code to reset 2FA on your next login." ? "light" : "primary"}
                  >
                    Reset 2FA
                  </Button>
                )}
                {
                  verificationCode.length===0 || sendVerificationCodeMessage?.message === "Your Reset 2FA request has been submitted. Please use QR code to reset 2FA on your next login." && <Button  className={`btn btn-lg ${styles["button-reset-mfa"]}`}  onClick={() => {handleLoginRedirect()}} ><Person2OutlinedIcon className={`${styles.profileIconWhite} mr-1`}/>Log in</Button>
                }
                {sendVerificationCodeMessage?.message !== "Your Reset 2FA request has been submitted. Please use QR code to reset 2FA on your next login." && (
                  <span
                    className={resendDisabled ? `${styles["disabled-link"]}` : `${styles["resend-link"]} cpointer`}
                    onClick={() => {
                      if (!formSubmitting && !resendDisabled) sendVerificationCode();
                    }}
                  >
                    {resendDisabled ? `Resend Verification Code in ${Math.floor(timer / 60)}:${timer % 60 < 10 ? '0' : ''}${timer % 60}` : "Resend Verification Code"}
                  </span>
                )}
              </div>
            ) : (
              <div className={styles["send-verification-code-button"]}>
                {formSubmitting ? (
                  <Button
                    className={`mx-2 btn-border-light w-md-auto col-xs-12 btn btn-lg ${styles["button-reset-mfa"]}`}
                    variant="light"
                    disabled
                    // onClick={SubmitContactForm}
                  >
                    Sending Verification Code . . .
                  </Button>
                ) : (
                  <Button
                    className={`btn btn-lg ${styles["button-reset-mfa"]}`}
                    // onClick={() => emailRegEx.test(emailIdUsername) ? sendVerificationCode() : setverificationCodeError(true)}
                    onClick={() => {if(emailRegEx.test(emailIdUsername)){
                      sendVerificationCode()
                    }
                    else{
                      setverificationCodeError(true);
                      if(fastAccessPin.length===0){
                        setFastAccessPinError(true)
                      }
                      else{
                        setFastAccessPinError(false)
                      }
                    }}}
                  >
                    Send Verification Code
                  </Button>
                )}
              </div>
            )}
          </Container>
        </div>
      )}
    </Popup>
  );
};

export default ResetMFAPopup;
